import type { NovelItem } from '@app/_proto/Protos/novels';
import HomeContent from '@app/domains/home/components/HomeContent';

import { HOME_CONTENT_REVIEW_SCORE_FONT_STYLE, HOME_CONTENT_TITLE_FONT_STYLE } from '../styles';

type Props = {
    content: NovelItem | undefined;
    isLoading?: boolean;
};
export default function HomeSneakPeekContent({ content, isLoading }: Props) {
    return (
        <HomeContent content={content} isLoading={isLoading}>
            <HomeContent.Image />
            <div className="px-4 pt-4 text-gray-300">
                <HomeContent.ReviewScore className={HOME_CONTENT_REVIEW_SCORE_FONT_STYLE} />
                <HomeContent.Title className={HOME_CONTENT_TITLE_FONT_STYLE} />
            </div>
        </HomeContent>
    );
}
